import React from "react"
import { Entry, Label, Value } from "./OrderList"

type Props = {
  label: string
  value: string | number
}

const ListEntry = ({ label, value }: Props) => {
  return (
    <Entry>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Entry>
  )
}

export default ListEntry
